module.exports = __webpack_public_path__ + "static/media/blue-loader.904b44c2.svg";